"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = getFrontendI18nextConfiguration;

var _common = require("./common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFrontendI18nextConfiguration() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$detectionLocalSt = _ref.detectionLocalStorageKey,
      detectionLocalStorageKey = _ref$detectionLocalSt === undefined ? "i18n_lng" : _ref$detectionLocalSt,
      _ref$detectionOrder = _ref.detectionOrder,
      detectionOrder = _ref$detectionOrder === undefined ? ["querystring", "cookie", "localStorage", "navigator"] : _ref$detectionOrder,
      _ref$enableLocalStora = _ref.enableLocalStorage,
      enableLocalStorage = _ref$enableLocalStora === undefined ? true : _ref$enableLocalStora,
      _ref$localStorageExpi = _ref.localStorageExpirationTime,
      localStorageExpirationTime = _ref$localStorageExpi === undefined ? 86400000 : _ref$localStorageExpi,
      _ref$localStoragePref = _ref.localStoragePrefix,
      localStoragePrefix = _ref$localStoragePref === undefined ? "i18n_" : _ref$localStoragePref,
      commonSettings = (0, _objectWithoutProperties3.default)(_ref, ["detectionLocalStorageKey", "detectionOrder", "enableLocalStorage", "localStorageExpirationTime", "localStoragePrefix"]);

  var frontendConfiguration = (0, _common2.default)((0, _extends3.default)({
    detectionOrder: detectionOrder
  }, commonSettings));

  frontendConfiguration.cache = {
    enabled: enableLocalStorage,
    expirationTime: localStorageExpirationTime,
    prefix: localStoragePrefix
  };

  frontendConfiguration.detection.lookupLocalStorage = detectionLocalStorageKey;

  return frontendConfiguration;
} /**
   * Copyright 2013-present, Novivia, Inc.
   * All rights reserved.
   */

// eslint-disable-next-line filenames/match-exported
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/localization/config/i18next/frontend.js
// module id = 882
// module chunks = 6